import { Link, useParams, useLocation } from 'react-router-dom';
import Card from '../common/Card';

type TabType = 'general' | 'scheduling' | 'staffing' | 'permissions' | 'shift-types' | 'preferences';

interface Tab {
  id: TabType;
  name: string;
  href: string;
}

export const TeamSettingsTabs = () => {
  const { teamId } = useParams<{ teamId: string }>();
  const location = useLocation();
  
  const tabs: Tab[] = [
    { id: 'general', name: 'General', href: `/teams/${teamId}/settings` },
    { id: 'scheduling', name: 'Scheduling Rules', href: `/teams/${teamId}/settings/scheduling` },
    { id: 'staffing', name: 'Staffing Requirements', href: `/teams/${teamId}/settings/staffing` },
    { id: 'shift-types', name: 'Shift Types', href: `/teams/${teamId}/shift-types` },
    { id: 'preferences', name: 'Preferences', href: `/teams/${teamId}/preferences` },
    { id: 'permissions', name: 'Permissions', href: `/teams/${teamId}/settings/permissions` }
  ];
  
  // Determine active tab based on the current path
  const getActiveTab = (): TabType => {
    if (location.pathname.endsWith('/scheduling')) return 'scheduling';
    if (location.pathname.endsWith('/staffing')) return 'staffing';
    if (location.pathname.endsWith('/shift-types')) return 'shift-types';
    if (location.pathname.endsWith('/preferences')) return 'preferences';
    if (location.pathname.endsWith('/permissions')) return 'permissions';
    return 'general';
  };
  
  const activeTab = getActiveTab();
  
  return (
    <Card className="mb-6">
      <div className="border-b border-gray-200">
        <nav className="flex -mb-px overflow-x-auto">
          {tabs.map((tab) => (
            <Link
              key={tab.id}
              to={tab.href}
              className={`
                py-4 px-6 border-b-2 font-medium text-sm whitespace-nowrap
                ${activeTab === tab.id
                  ? 'border-primary text-primary'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}
              `}
            >
              {tab.name}
            </Link>
          ))}
        </nav>
      </div>
    </Card>
  );
}; 